@if (hasBreadcrumbs()) {
  <neo-breadcrumb
    [containerAriaLabel]="ariaLabel()"
    [maxVisible]="maxVisible()"
    [autId]="autId()"
  />
}
